import type {
  HeroImageType,
  ImageCarouselType,
  LeftRightListType,
  StandardHeaderTextType,
  SubtitleType,
  TableType,
  TextType,
} from '../../models/ContentManagementInterface';
import {
  generateHeroImageType,
  generateImageCarouselType,
  generateLeftRightListType,
  generateStandardHeaderTextType,
  generateSubtitleType,
  generateTableType,
  generateTextType,
} from '../../services/TemplateUtils';

export type FundUpdateBlockType =
  | 'StandardHeaderText'
  | 'Subtitle'
  | 'Text'
  | 'HeroImage'
  | 'ImageCarousel'
  | 'LeftRightList'
  | 'Table';

export function createNewBlock(
  type: FundUpdateBlockType,
  fundOpportunityId: string,
):
  | StandardHeaderTextType
  | SubtitleType
  | TextType
  | HeroImageType
  | ImageCarouselType
  | LeftRightListType
  | TableType {
  switch (type) {
    case 'StandardHeaderText':
      return generateStandardHeaderTextType();
    case 'Subtitle':
      return generateSubtitleType();
    case 'Text':
      return generateTextType();
    case 'HeroImage':
      return generateHeroImageType();
    case 'ImageCarousel': {
      const base = generateImageCarouselType(fundOpportunityId, 'FundUpdate');
      return { ...base, properties: { ...base.properties, items: [] } };
    }
    case 'LeftRightList':
      return generateLeftRightListType();
    case 'Table':
      return generateTableType();
  }
}
